import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import {
  PORTFOLIO_ACCESS,
  type PortfolioAccess,
} from 'lumen/components/settings/currency-conversion/profile';
import { USER_ENGAGEMENT_ELEMENT_IDS } from 'lumen/models/seen-user-engagement-element';
import type HotelSettingsCurrencyConversionIndexRoute from 'lumen/routes/hotel/settings/currency-conversion/index';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCurrencyConversionIndexController extends Controller {
  declare model: ModelFrom<HotelSettingsCurrencyConversionIndexRoute>;

  queryParams = ['profileNotFound'];
  @service declare access: Services['access'];
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service declare router: Services['router'];
  @service declare userEngagement: Services['user-engagement'];
  @tracked isBannerDismissed = false;
  @tracked profileNotFound: boolean = false;

  get portfolioAccess(): PortfolioAccess | null {
    if (!this.hotelAndMarketService.hotel?.spiderMarketId) {
      return null;
    }
    return this.access.hasCurrencyConversionEditAccess
      ? PORTFOLIO_ACCESS.EDIT
      : PORTFOLIO_ACCESS.VIEW;
  }

  get showProfileNotFoundModal(): boolean {
    return this.profileNotFound === true;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showUserOnboardingModal() {
    return !this.userEngagement.hasSeen(
      USER_ENGAGEMENT_ELEMENT_IDS.HOTEL_CURRENCY_CONVERSION_ONBOARDING_MODAL,
    );
  }

  @action
  closeProfileNotFoundModal(): void {
    this.profileNotFound = false;
  }

  @action
  closeUserOnboardingModal(): void {
    this.userEngagement.markAsSeen(
      USER_ENGAGEMENT_ELEMENT_IDS.HOTEL_CURRENCY_CONVERSION_ONBOARDING_MODAL,
    );
  }

  @action
  dismissBanner(): void {
    this.isBannerDismissed = true;
  }

  @action
  navigateToPortfolio(): void {
    // spiderMarketId is guaranteed non-null when portfolioAccess is set
    void this.router.transitionTo(
      'market.settings.currency-conversion.index',
      this.hotelAndMarketService.hotel.spiderMarketId!,
    );
  }
}
